import PackageIcon from "@redotech/redo-icons/package.svg";
import { Carriers } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import { isEnumValue } from "@redotech/util/enum";
import classNames from "classnames";
import { memo, useMemo } from "react";
import { getCarrierLogoUrl } from "../../carrier/logo";
import { Flex } from "../../flex";
import * as css from "./shipping-logo.module.css";

export enum LogoSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export const ShippingLogo = memo(function ShippingLogo({
  carrier,
  size,
}: {
  carrier: Carriers | string | null;
  size: LogoSize;
}) {
  const logoUrl = useMemo(() => {
    return carrier ? getCarrierLogoUrl(carrier) : "";
  }, [carrier]);

  const showBorderRadius =
    !!isEnumValue(carrier, Carriers) &&
    ![Carriers.UPS_SUREPOST, Carriers.UPS].includes(carrier);

  return (
    <Flex
      className={classNames(
        css.logoContainer,
        size === LogoSize.SMALL && css.small,
        size === LogoSize.LARGE && css.large,
      )}
      flexDirection="column"
      justify="center"
    >
      {logoUrl !== "" && (
        <img
          className={classNames(
            css.nameLogo,
            size === LogoSize.SMALL && css.small,
            size === LogoSize.LARGE && css.large,
            showBorderRadius && css.borderRadius,
          )}
          src={logoUrl}
        />
      )}
      {logoUrl === "" && (
        <PackageIcon
          classNames={classNames(
            css.nameLogo,
            size === LogoSize.SMALL && css.small,
            size === LogoSize.LARGE && css.large,
            showBorderRadius && css.borderRadius,
          )}
          height={24}
          width={24}
        />
      )}
    </Flex>
  );
});
